import {
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ModalComponent } from '../../ui-components/modal/modal.component';
import { AccountBalances, CreditAccount } from '@enrollhere/classes';
import { AccountBalancesDetailComponent } from '../../account/account-balances-detail/account-balances-detail.component';
import { PayoutsOverviewComponent } from '../../../../components/payouts/payouts-overview/payouts-overview.component';

@Component({
  selector: 'app-payouts-overview-modal',
  standalone: true,
  imports: [
    AccountBalancesDetailComponent,
    ModalComponent,
    PayoutsOverviewComponent,
  ],
  templateUrl: './payouts-overview-modal.component.html',
  styleUrl: './payouts-overview-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PayoutsOverviewModalComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() openWith?: {
    userId: string;
    balances?: { accounts: CreditAccount[]; balances: AccountBalances };
    accounts?: CreditAccount[];
  };
  @Output() valueChanged = new EventEmitter<unknown>();
  @Output() modalDismissedFired = new EventEmitter<boolean>();

  @ViewChild('modal') modal?: ModalComponent;

  userId?: string;
  balances?: { accounts: CreditAccount[]; balances: AccountBalances };
  accounts?: CreditAccount[];

  ngAfterViewInit() {
    if (this.openWith) {
      this.open(
        this.openWith.userId,
        this.openWith.balances,
        this.openWith.accounts
      );
      this.cdr.detectChanges();
    }
  }

  open(
    userId: string,
    balances?: { accounts: CreditAccount[]; balances: AccountBalances },
    accounts?: CreditAccount[]
  ) {
    this.userId = userId;
    this.balances = balances;
    this.accounts = accounts;
    this.modal?.show();
    this.cdr.detectChanges();
  }
}
